export const DomainValidationType = {
  Bwt: 'BWT',
  Uet: 'UET',
};

export const supportedContactMarket = [
  { value: 'en-US', text: _TL_('English - United States') },
  { value: 'en-AU', text: _TL_('English - Australia') },
  { value: 'en-GB', text: _TL_('English - United Kingdom') },
  { value: 'fr-FR', text: _TL_('French - French') },
  { value: 'de-DE', text: _TL_('German - Germany') },
  { value: 'ja-JP', text: _TL_('Japanese - Japan') },
];

export const supportedContactMarketCN = [
  { value: 'zh-CN', text: _TL_('Simplified Chinese - China') },
];

export const automaticItemUpdateOptions = [
  { value: 'PriceOnly', text: _TL_('Price only') },
  { value: 'AvailabilityOnly', text: _TL_('Availability only') },
  { value: 'PriceAndAvailability', text: _TL_('Price and availability') },
];
